import { render, staticRenderFns } from "./StarsRate.vue?vue&type=template&id=7c193d42&scoped=true&"
import script from "./StarsRate.vue?vue&type=script&lang=ts&setup=true&"
export * from "./StarsRate.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./StarsRate.vue?vue&type=style&index=0&id=7c193d42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c193d42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c193d42')) {
      api.createRecord('7c193d42', component.options)
    } else {
      api.reload('7c193d42', component.options)
    }
    module.hot.accept("./StarsRate.vue?vue&type=template&id=7c193d42&scoped=true&", function () {
      api.rerender('7c193d42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/StarsRate/StarsRate.vue"
export default component.exports